import React, {FC} from 'react';
import styled from 'styled-components';

import {AnalyticsPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {FilterDropdownBox} from '../../../../../libs/shared/ui/src/components/filters/filterDropdownBox';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {analyticsFilterColor} from '../../filters/common/helpers';
import {useAnalyticsChatbotsFilter} from '../../filters/useAnalyticsChatbotsFilter';
import {ReportHeaderDatepicker} from '../../reportHeader/titleRow/reportHeaderDatepicker';

/*
 * Props.
 */

interface ReportHeaderChatbotFiltersProps {
  panelId: AnalyticsPanelId;
}

/*
 * Styles.
 */

const StyledHeaderFiltersDiv = styled.div`
  display: flex;
  align-items: flex-start;

  justify-content: space-between;
`;

const StyledFiltersWrapperDiv = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
`;

const StyledFilterBarItemWrapperDiv = styled.div`
  max-width: 300px;
`;

/*
 * Component.
 */

export const ReportHeaderChatbotFilters: FC<ReportHeaderChatbotFiltersProps> = ({panelId}) => {
  const theme = useUserTheme();

  const {isActive, isDisabled, renderDropdown, renderButton} = useAnalyticsChatbotsFilter();

  return (
    <StyledHeaderFiltersDiv>
      <StyledFiltersWrapperDiv>
        <div>
          <ReportHeaderDatepicker color={analyticsFilterColor.findBase(theme)} panelId={panelId} />
        </div>

        <StyledFilterBarItemWrapperDiv>
          <FilterDropdownBox
            isActive={isActive}
            renderButton={renderButton}
            renderDropdown={renderDropdown}
            color={analyticsFilterColor.findBase(theme)}
            isDisabled={isDisabled}
          />
        </StyledFilterBarItemWrapperDiv>
      </StyledFiltersWrapperDiv>
    </StyledHeaderFiltersDiv>
  );
};
